import { memo } from 'react';
import { DraggableListScrollDroppable, DraggableListWrapper } from '@styles/InputStyles';
import { DraggableListItem } from './DraggableListItem';

export interface IDraggableItem {
    id: number | string;
    text?: string;
    color?: string;
    sortName?: string;
    backgroundHexColor?: string;
    textHexColor?: string;
    stageOrStatus?: string;
    isDelayOfStage?: number | null;
}

export type DraggableListProps = {
  items: IDraggableItem[];
  droppableId: string;
  showScroll?: boolean;
};

export const DraggableList = memo(({ items, droppableId, showScroll = false }: DraggableListProps) => (
  <DraggableListScrollDroppable droppableId={droppableId}>
    {(provided) => (
      <DraggableListWrapper showScroll={showScroll} {...provided.droppableProps} ref={provided.innerRef}>
        {items.map((item, index) => (
          <DraggableListItem
            key={item.id}
            id={droppableId + '-' + item.id}
            index={index}
            text={item.sortName || item.text || ''}
            backgroundColor={item.backgroundHexColor}
            textHexColor={item.textHexColor}
          />
        ))}
        {provided.placeholder}
      </DraggableListWrapper>
    )}
  </DraggableListScrollDroppable>
));
